export default __webpack_public_path__ + "static/media/oyster.1dec05c0.png";